import React, { useEffect, useState, useRef } from "react"
import { useParams, withRouter } from "react-router-dom"
import { useSelector, connect, useDispatch } from "react-redux"
// import { useSelector, connect, useDispatch } from "react-redux"
import Select from "react-select"
import {
  Row,
  Col,
  UncontrolledTooltip,
  Button,
  Table,
  Label,
  Input,
} from "reactstrap"
//import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as ecFollowupAction from "../../store/ZWNGb2xsb3d1cA/actions"
import { ToastContainer, toast } from "react-toastify"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import api from "helpers/Api"
import moment from "moment"
import SimpleReactValidator from "simple-react-validator"

// import Modal from "react-bootstrap/Modal"

const ECFollowup = (props) => {
  const specificDispatch = useDispatch()
  let { id } = useParams()

  const { dispatch, modeMenu } = props
  const currentDate = moment().format("YYYY-MM-DD")
  // console.log(currentDate, "currentDate")
  const currentTime = moment().format("LT")
  const [followupReasonData, setFollowupReasonData] = useState("")

  useEffect(() => {
    dispatch(ecFollowupAction.loadRecordsMetaData())
    specificDispatch(ecFollowupAction.loadEcFollowupList(id))
    setFollowUpData({
      followUpDate: currentDate,
      time: currentTime,
    })
    api
      .post("get_Followup_Reason", { status: "active" })
      .then((res) => {
        setFollowupReasonData(res.data.data)
        res.data
      })
      .catch((error) => Promise.reject(error))
  }, [])

  //React Validations
  const simpleValidator = useRef(new SimpleReactValidator())

  const [, forceUpdate] = useState()

  const update = useSelector((state) => state.session)
  const ecUpdate = useSelector((state) => state.ecFollowup)
  console.log(update, "myUpdate", id)
  const { user = [] } = update
  const { recordsMetaData = {}, ec_followup_list } = ecUpdate

  console.log(user, "user")
  console.log(ec_followup_list, "ec_followup_list", recordsMetaData)

  console.log(currentDate, currentTime, "currentDate")
  //Ec Followup State section

  const [ecFollowupModal, setECFollowupModal] = useState(false)

  const [isEdit, setIsEdit] = useState(false)
  //followup modal data
  const [followUpData, setFollowUpData] = useState({
    followUpDate: "",
    time: "",
    reachStatus: "",
    followUpRemarks: "",
    followupMode: "",
    followupStatus: "",
    attachment: [],
  })
  //handle change

  const handleFollowUpChange = async (e) => {
    setFollowUpData({ ...followUpData, [e.target.name]: e.target.value })
  }

  const followupReasonList =
    !isEmpty(followupReasonData) && followupReasonData.length > 0
      ? followupReasonData.map((data) => {
          return {
            followupReason: data.followupReason,
            _id: data._id,
          }
        })
      : []

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.followupReason

        options.push(obj)
      })
    return options
  }

  const followupReasonOptions = createOptions(followupReasonList)
  console.log(followupReasonData, "followupReasonData")
  console.log(followupReasonOptions, "followupReasonOptions")
  //Add Followup modal
  const addFollowupModalDetails = () => {
    setECFollowupModal(true)
    setFollowUpData({
      followUpRemarks: "",
      followUpDate: currentDate,
      time: currentTime,
    })
    setFollowUpMode([])
    setFileName("")
    setFileLength("")
    setFollowUpStatus([])
    setUploadInput([])
    setRadioOption({ option: "", checked: "" })
  }

  //folowwup dropdown initial state
  const [followUpMode, setFollowUpMode] = useState([])
  const [followupId, setFollowupId] = useState("")

  const [followUpStatus, setFollowUpStatus] = useState([])

  const [uploadInput, setUploadInput] = useState([])

  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")

  //Connect options
  //dynamic radio button 1
  const [radioOption, setRadioOption] = useState({ option: "", checked: "" })

  const connectOptions = [
    { id: 1, option: "Completed", label: "Completed" },
    { id: 2, option: "NotCompleted", label: "Not Completed" },
  ]

  const handleOptionsChange = (e, index) => {
    let value = connectOptions[0].option
    setRadioOption({ option: value, checked: index })
  }

  //Attachment Change

  const uploadChange = async (e) => {
    if (e.target.files) {
      // console.log("qqqq", e.target.files)
      setUploadInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadInput(teamUploadValue)
          }
        })
      }
    }
  }
  console.log(uploadInput, "uploadInput")

  //Add EC FOllowup
  const addFollowup = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      let ecFollowupData = {
        leadId: id,
        followupDate: followUpData.followUpDate,
        time: followUpData.time,
        followupMode: followUpMode.value,
        reachStatus: radioOption.option,
        followupRemarks: followUpData.followUpRemarks,
        attachment: uploadInput.map((data) => data),
        followupReason: followUpStatus.value,
      }
      specificDispatch(ecFollowupAction.addEcFollowup(ecFollowupData))
      setTimeout(() => {
        // setIsEdit(false)
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setECFollowupModal(false)
        specificDispatch(ecFollowupAction.loadEcFollowupList(id))
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setECFollowupModal(true)
    }
  }
  //Edit EC FOllowup
  const editFollowup = (followup) => {
    const followupReason = !isEmpty(followup.followupReason)
      ? followup.followupReason
      : ""
    console.log(followup, "followup")
    setFollowUpMode({
      label: followup.followupMode.followupMaster,
      value: followup.followupMode._id,
    })
    setFollowUpStatus({
      label: followupReason.followupReason,
      value: followupReason._id,
    }),
      setFollowUpData({
        followUpDate: moment(followup.followupDate).format("YYYY-MM-DD"),
        time: followup.time,
        // reachStatus: followup.reachStatus,
        followUpRemarks: followup.followupRemarks,
        followupMode: [
          {
            label: followup.followupMode.followupMaster,
            value: followup.followupMode._id,
          },
        ],
        followupStatus: [
          {
            label: followupReason.followupReason,
            value: followupReason._id,
          },
        ],
        attachment: followup.attachment,
      })
    setRadioOption({
      option: followup.reachStatus,
      checked: followup.reachStatus === "Completed" ? 0 : 1,
    })
    setFileLength(followup.attachment.length)
    setFileName(followup.attachment[0])
    setFollowupId(followup._id)
    setUploadInput(followup.attachment)
    setIsEdit(true)
    setECFollowupModal(true)
  }

  //Update EC FOllowup
  const updateFollowup = () => {
    let ecFollowupData = {
      _id: followupId,
      leadId: id,
      followupDate: followUpData.followUpDate,
      time: followUpData.time,
      followupMode: followUpMode.value,
      reachStatus: radioOption.option,
      followupRemarks: followUpData.followUpRemarks,
      attachment: uploadInput.map((data) => data),
      followupReason: followUpStatus.value,
    }
    specificDispatch(ecFollowupAction.updateEcFollowup(ecFollowupData))
    setTimeout(() => {
      setIsEdit(false)
      toast.success("Records Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      setECFollowupModal(false)
      specificDispatch(ecFollowupAction.loadEcFollowupList(id))
    }, 1500)
  }

  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <Col lg="9" md="9" sm="6" xs="6" className="d-flex flex-row">
          <p className="quote-head">
            EC Followup
            <span className="quote-info">
              <i
                style={{ color: "grey" }}
                id="quoteInfo1"
                aria-hidden="true"
                className="fa fa-info-circle ms-1"
              ></i>
              <UncontrolledTooltip placement="right" target="quoteInfo1">
                EC Followup
              </UncontrolledTooltip>
            </span>
          </p>
          {modeMenu === "EventComplete" ? (
            ""
          ) : (
            <div
              className="ec-followup-btn"
              onClick={() => {
                addFollowupModalDetails()
              }}
            >
              Add Followup
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col className="mt-3">
          <Table bordered responsive>
            <thead style={{ backgroundColor: "#f9f9f9" }}>
              <tr>
                <th>S.No</th>
                <th>Action</th>
                <th>Follow-up No</th>
                <th>Followup Date</th>
                <th>Time</th>
                <th>Mode</th>
                <th>Reach Status</th>
                <th>Followup Reason</th>
                <th>Attachment</th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(ec_followup_list) && ec_followup_list.length > 0 ? (
                ec_followup_list.map((followup, index) => {
                  console.log(followup, "followup")
                  var attachments = !isEmpty(followup.attachment)
                    ? followup.attachment.map((f) => f)
                    : []
                  //   const fileUrl = isEmpty(followup.attachment)
                  //   ? ""
                  //   : followup.attachment.map((data) =>
                  //       data.split(".").pop()
                  //     )

                  return (
                    <>
                      <tr key={index}>
                        <td>
                          {/* {!isEmpty(followup) && followup.departmentName
                            ? followup.departmentName
                            : ""} */}
                          {index + 1}
                        </td>
                        <td>
                          <button
                            type="submit"
                            className="btn btn-success"
                            onClick={() => {
                              editFollowup(followup)
                            }}
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                        </td>
                        <td>
                          {!isEmpty(followup) && followup.followupNumber
                            ? followup.followupNumber
                            : ""}
                        </td>
                        <td>
                          {!isEmpty(followup) && followup.followupDate
                            ? moment(followup.followupDate).format("DD-MM-YYYY")
                            : ""}
                        </td>
                        <td>
                          {!isEmpty(followup) && followup.time
                            ? followup.time
                            : ""}
                        </td>
                        <td>
                          {!isEmpty(followup.followupMode)
                            ? followup.followupMode.followupMaster
                            : "--"}
                        </td>
                        <td>{followup.reachStatus}</td>
                        <td>
                          {!isEmpty(followup.followupReason)
                            ? followup.followupReason.followupReason
                            : ""}
                        </td>
                        <td>
                          <a onClick={() => window.open(attachments, "_blank")}>
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#E40D8C",
                              }}
                            >
                              View
                            </span>
                          </a>
                        </td>
                      </tr>
                    </>
                  )
                })
              ) : (
                <>
                  <tr key={0}>
                    <td colSpan={9} className="text-align-center">
                      No record found
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
      {ecFollowupModal && (
        <Row
          style={{ margin: "10px 0px" }}
          className="d-flex flex-row ec-followup-form-content"
        >
          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                {"Follow-Up-Date"}
                <span className="required">*</span>
              </Label>
            </div>
            <Input
              type="date"
              placeholder="Select Date"
              name="followUpDate"
              value={followUpData.followUpDate}
              onChange={(e) => handleFollowUpChange(e)}
              disabled
            />
          </Col>
          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className="form-label" htmlFor={"Time"}>
                {"Time"}
                <span className="required">*</span>
              </Label>
            </div>
            <Input
              type="text"
              placeholder="Select Date"
              name="time"
              value={followUpData.time}
              onChange={(e) => handleFollowUpChange(e)}
              disabled
            />
          </Col>
          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className={"form-label"}>
                {"Follow-Up-Mode"}
                <span className="required">*</span>
              </Label>
            </div>
            <Select
              type="text"
              name="followUpMode"
              value={followUpMode}
              onChange={(e) => setFollowUpMode(e)}
              options={
                recordsMetaData ? recordsMetaData.followUpModeOptions : []
              }
              placeholder="Select Follow Up Mode"
              classNamePrefix="select2-selection"
            />
            <div style={{ textTransform: "capitalize" }}>
              {simpleValidator.current.message(
                "followUpMode",
                followUpMode,
                "required"
              )}
            </div>
          </Col>
          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className={"form-label"}>
                {"Reach Status"}
                <span className="required">*</span>
              </Label>
            </div>
            <div className="d-flex flex-row">
              {connectOptions.map((item, index) => {
                return (
                  <>
                    <div className="form-check form-check-inline">
                      <Input
                        type="radio"
                        key={item.id}
                        name="Reach Status"
                        value={radioOption.option}
                        checked={radioOption.checked === index}
                        onChange={(e) => handleOptionsChange(e, index)}
                      />

                      <Label>{item.label}</Label>
                    </div>
                  </>
                )
              })}
            </div>
            <div style={{ textTransform: "capitalize" }}>
              {simpleValidator.current.message(
                "Reach Status",
                radioOption.option,
                "required"
              )}
            </div>
          </Col>
          <Col md="6" lg="6" sm="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className="form-label" htmlFor={"Time"}>
                {"Follow-Up-Remarks"} {""}{" "}
                <span className="text-decoration-underline text-info">
                  History
                </span>
                <span className="required">*</span>
              </Label>
            </div>
            <Input
              type="textarea"
              placeholder="Enter Follow Up Remarks"
              name="followUpRemarks"
              value={followUpData.followUpRemarks}
              onChange={(e) => handleFollowUpChange(e)}
            />
            <div style={{ textTransform: "capitalize" }}>
              {simpleValidator.current.message(
                "followUpRemarks",
                followUpData.followUpRemarks,
                "required"
              )}
            </div>
          </Col>

          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className={"form-label"}>
                {"Attachment"}
                <span className="required">*</span>
              </Label>
            </div>
            <Button className=" btn btn-warning  position-relative fs-5">
              <i className="fas fa-laptop"></i>

              <Input
                type="file"
                name="uploadInput"
                accept="application/pdf, audio/mp3 , image/jpeg"
                // id="upload-btn"
                multiple
                onChange={(e) => uploadChange(e)}
                style={{
                  position: "absolute",
                  fontSize: "50px",
                  opacity: 0,
                  right: 0,
                  top: 0,
                }}
              />
              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                {fileLength ? fileLength : 0}
              </span>
            </Button>
            <div className="text-decoration-underline text-danger">
              {fileName ? fileName : ""}
            </div>
            <div style={{ textTransform: "capitalize" }}>
              {simpleValidator.current.message(
                "Attachment",
                uploadInput,
                "required"
              )}
            </div>
          </Col>
          <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
            <div className="d-flex justify-content-between">
              <Label className={"form-label"}>
                {"Follow-Up-Reason"}
                <span className="required">*</span>
              </Label>
            </div>
            <Select
              //   type="text"
              name="followUpStatus"
              value={followUpStatus}
              onChange={(e) => setFollowUpStatus(e)}
              options={followupReasonOptions}
              placeholder="Select Follow Up Reason"
              classNamePrefix="select2-selection"
            />
            <div style={{ textTransform: "capitalize" }}>
              {simpleValidator.current.message(
                "followUpStatus",
                followUpStatus,
                "required"
              )}
            </div>
          </Col>
          <Col md="12" xl="12" lg="12" className="mt-4">
            <div style={{ float: "right" }} className="d-flex flex-row">
              <Button
                type="button"
                // variant="primary"
                className="btn btn-danger"
                onClick={() => {
                  setECFollowupModal(false)
                }}
              >
                Cancel
              </Button>
              {isEdit ? (
                <Button
                  type="button"
                  variant="primary"
                  className="btn btn-success mx-2"
                  onClick={() => {
                    updateFollowup()
                  }}
                >
                  Update
                </Button>
              ) : (
                <Button
                  type="button"
                  variant="primary"
                  className="btn btn-success mx-2"
                  onClick={(e) => {
                    addFollowup(e)
                  }}
                >
                  Submit
                </Button>
              )}
            </div>
          </Col>
        </Row>
      )}

      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

ECFollowup.propTypes = {
  dispatch: PropTypes.func,
  clientProfile: PropTypes.array,
  location: PropTypes.array,
  modeMenu: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ECFollowup)
)
